import { cn } from '~/lib/utils';
import styles from './Caret.module.css';
import type { ChatTheme } from './theme';
import { chatThemeClass } from './theme';
import { useV15Theme } from '~/design-system/components/v1_5/theme-context';

export interface CaretProps {
  theme?: ChatTheme;
  /**
   * The editing bubble offsets its caret by `margin-left: 2px`, which is the bubble's
   * concern, not the caret's — the caret itself is the same 1.5x19 block everywhere it appears.
   */
  className?: string;
}

/**
 * The text caret, drawn rather than typed: a 1.5x19 block of `--cv15-text`.
 *
 * It exists because several artboards are showing a composer or a bubble mid-edit, and a real
 * `<textarea>` caret does not survive a screenshot. It is the last item in a `ComposerTextRow`'s
 * chip flow (*Mentions*, *Mention menu*, *Mention chip*, *Designer · edit loop*) and the last
 * item inside the *Editing* bubble.
 *
 * Purely decorative — the accessible object is the field it sits in, so it is hidden from AT.
 */
export function Caret({ theme: themeProp, className }: CaretProps) {
  const theme = useV15Theme(themeProp);
  return (
    <span aria-hidden="true" className={cn(chatThemeClass(theme), styles.caret, className)} />
  );
}
